module.exports = __webpack_public_path__ + "img/drug_pill.91347a05.svg";